/**
 * @description 支持输入区间并带单位
 * @param {Any} value 用户输入值
 * @param {Number} digit 倍率，小数位数 如： 0.01 -> 2
 * @param {Array} units 可选单位集
 * @param {Array} range 可输入范围集 ！注意： 此方法不包含e[0]和e[1]的临界值，即无<=或>=，如有需要可根据倍率在配置文件中修改
 */
function rangeUnit(value, digit, units, range) {
	return units.some((item) => {
		let val = value.split("");
		const valUnit = val.splice(0 - item.length);
		const newVal = Number(val.join(""));
		if (!newVal) return false;
		// 判断小数位数
		if (val.join("").split(".")[1] && val.join("").split(".")[1].length > digit) return false;
		if (valUnit.join("") === item) {
			return range.some((e) => {
				if (!Number(e[0]) || !Number(e[0])) return false;
				let firstResult;
				let secondResult;
				if (e[0] !== null) {
					// null代表不进行比较小于区间
					firstResult = newVal > Number(e[0]);
				} else {
					firstResult = true;
				}
				if (e[1] !== null) {
					// null代表不进行比较小于区间
					secondResult = newVal < Number(e[1]);
				} else {
					secondResult = true;
				}
				return firstResult && secondResult;
			});
		}
		return false;
	});
}

/**
 * @description 针对1310有功百分比读取的特殊处理
 * @param {*} value
 */
function analysis1310(value) {
	const val = Number(value);
	if (!val) return "";
	let result = val;
	if (val >= 1 && val <= 100) {
		result = `${getLanguageStr("plant_detail39", "开")}: ${val}%`;
	} else if (val === 255) {
		result = `${getLanguageStr("plant_detail38", "关")}`;
	}
	return result;
}

const specialCheckFn = {
	rangeUnit,
	"fn-1310": analysis1310,
};

export default specialCheckFn;



// WEBPACK FOOTER //
// ./src/util/rule.js